/**
 * zIndex
 * use zIndex wisely, try not to add z index unnecessarily
 */
enum zIndexList {
    ToastContainer = 2147483647,
    bottomSheet = 99999999,
    modal = 1100,
}

/**
 * SCSS variables
 */

/**
 * file - dashboard.module.scss
 * .topSection - zIndex: 100
 * Used in advance filter bottom sheet - listing page
 * reason sticky filter header has zindex 1 but bottom and top nav has 100 so need to match it
 */

export default zIndexList;
